<script setup lang="ts">
interface DropdownProps {
  position?:
    | "is-top-right"
    | "is-top-left"
    | "is-bottom-right"
    | "is-bottom-left";
  disabled?: boolean;
  label?: string;
  ariaRole?: "list" | "menu";
  mobileModal?: boolean;
}
const {
  position = "is-bottom-right",
  disabled = false,
  label = "",
  ariaRole = "list",
  mobileModal = true
} = defineProps<DropdownProps>();

const chevronIcon = (active: boolean) =>
  active ? "chevron-up" : "chevron-down";
</script>
<template>
  <b-dropdown
    :aria-role="ariaRole"
    :position="position"
    :disabled="disabled"
    :mobile-modal="mobileModal"
  >
    <template #trigger="{ active }">
      <slot name="trigger" :active="active" :icon="chevronIcon(active)">
        <b-button
          :label="label"
          :disabled="disabled"
          :icon-right="chevronIcon(active)"
        >
          {{ label }}
        </b-button>
      </slot>
    </template>
    <slot />
  </b-dropdown>
</template>
